const UserActions = {
    TTICAL: 'TT-ICAL',
    OHAICAL: 'OHA-ICAL',
    VIDEOTUTORIAL: 'VIDEO-TUTORIAL',
    ICALSUBSCRIPTION: "ICAL-SUBSCRIPTION"
};

export default UserActions;
